// src/components/FullScreenLoader.jsx
import Loader from "./loader";

const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 z-50 bg-white/80 backdrop-blur-sm flex items-center justify-center">
      <Loader size={160} />
    </div>
  );
};

export default FullScreenLoader;
